var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSelInfecteds(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.3274 20.1843L17.7386 18.5954C17.1725 18.0294 18.0286 17.1716 18.5954 17.7386L20.1843 19.3275C20.7504 19.8935 19.8942 20.7511 19.3274 20.1843Z",
    fill: "#9F9F9F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.5187 16.1059H19.2717C18.471 16.1059 18.4702 14.8941 19.2717 14.8941H21.5187C22.3194 14.8941 22.3202 16.1059 21.5187 16.1059Z",
    fill: "#9F9F9F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.7386 12.4046L19.3274 10.8157C19.8935 10.2495 20.751 11.1059 20.1843 11.6726L18.5954 13.2615C18.0293 13.8276 17.1718 12.9713 17.7386 12.4046Z",
    fill: "#9F9F9F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.3384 21.5104C18.7395 20.9116 18.7395 19.9372 19.3384 19.3384C19.9372 18.7396 20.9116 18.7395 21.5104 19.3384C22.1092 19.9372 22.1092 20.9116 21.5104 21.5104C20.9116 22.1091 19.9372 22.1093 19.3384 21.5104Z",
    fill: "#CACACA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.4641 17.0358C21.6173 17.0358 20.9283 16.3469 20.9283 15.5C20.9283 14.653 21.6173 13.9641 22.4641 13.9641C23.311 13.9641 24 14.653 24 15.5C24 16.3469 23.311 17.0358 22.4641 17.0358Z",
    fill: "#CACACA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.3384 11.6616C18.7395 11.0628 18.7395 10.0884 19.3384 9.48957C19.9372 8.89076 20.9116 8.89069 21.5104 9.48957C22.1092 10.0884 22.1092 11.0628 21.5104 11.6616C20.9116 12.2604 19.9372 12.2605 19.3384 11.6616Z",
    fill: "#CACACA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.5 12.3342C15.1654 12.3342 14.8941 12.0629 14.8941 11.7283V9.48127C14.8941 8.68061 16.1059 8.67978 16.1059 9.48127V11.7283C16.1059 12.0629 15.8346 12.3342 15.5 12.3342Z",
    fill: "#CACACA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.5 8.87537V12.3342C15.8346 12.3342 16.1059 12.0629 16.1059 11.7283V9.48129C16.1059 9.14664 15.8346 8.87537 15.5 8.87537Z",
    fill: "#9F9F9F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.8941 21.5187V19.2717C14.8941 18.471 16.1059 18.4702 16.1059 19.2717V21.5187C16.1059 22.3194 14.8941 22.3202 14.8941 21.5187Z",
    fill: "#CACACA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.5 18.6658V22.1246C15.8346 22.1246 16.1059 21.8533 16.1059 21.5187V19.2717C16.1059 18.937 15.8346 18.6658 15.5 18.6658Z",
    fill: "#9F9F9F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.4045 13.2615L10.8157 11.6726C10.2496 11.1065 11.1057 10.2488 11.6725 10.8157L13.2614 12.4046C13.8275 12.9706 12.9714 13.8283 12.4045 13.2615Z",
    fill: "#CACACA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.7283 16.1059H9.48127C8.68061 16.1059 8.67978 14.8941 9.48127 14.8941H11.7283C12.529 14.8941 12.5298 16.1059 11.7283 16.1059Z",
    fill: "#CACACA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.8157 19.3274L12.4045 17.7385C12.9707 17.1723 13.8282 18.0287 13.2614 18.5954L11.6726 20.1842C11.1111 20.7458 10.2417 19.9014 10.8157 19.3274Z",
    fill: "#CACACA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.5 10.0718C14.6531 10.0718 13.9641 9.38276 13.9641 8.53588C13.9641 7.68896 14.6531 7 15.5 7C16.3469 7 17.0359 7.68896 17.0359 8.53588C17.0359 9.38272 16.3469 10.0718 15.5 10.0718Z",
    fill: "#9F9F9F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.5 24C14.6531 24 13.9641 23.311 13.9641 22.4641C13.9641 21.6173 14.6531 20.9283 15.5 20.9283C16.3469 20.9283 17.0359 21.6173 17.0359 22.4641C17.0359 23.311 16.3469 24 15.5 24Z",
    fill: "#9F9F9F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.5 20.9283V24C16.3469 24 17.0359 23.311 17.0359 22.4641C17.0359 21.6173 16.3469 20.9283 15.5 20.9283Z",
    fill: "#CACACA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.48958 11.6616C8.88933 11.0614 8.88926 10.0898 9.48958 9.48954C10.0884 8.89079 11.0628 8.89069 11.6616 9.48954H11.6617C12.2605 10.0884 12.2605 11.0627 11.6617 11.6616C11.0629 12.2604 10.0885 12.2605 9.48958 11.6616Z",
    fill: "#9F9F9F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.53588 17.0358C7.689 17.0358 7 16.3469 7 15.5C7 14.6531 7.689 13.9641 8.53588 13.9641C9.38276 13.9641 10.0717 14.6531 10.0717 15.5C10.0717 16.3469 9.38272 17.0358 8.53588 17.0358Z",
    fill: "#9F9F9F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.48957 21.5104C8.88933 20.9102 8.88923 19.9387 9.48957 19.3384C10.0884 18.7396 11.0628 18.7395 11.6616 19.3384C12.2604 19.9372 12.2604 20.9116 11.6617 21.5104C11.0629 22.1091 10.0885 22.1093 9.48957 21.5104Z",
    fill: "#9F9F9F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.5 19.8776C13.0862 19.8776 11.1224 17.9138 11.1224 15.5C11.1224 13.0862 13.0862 11.1224 15.5 11.1224C17.9138 11.1224 19.8776 13.0862 19.8776 15.5C19.8776 17.9138 17.9138 19.8776 15.5 19.8776Z",
    fill: "#9F9F9F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.5 7V10.0718C16.3469 10.0718 17.0359 9.38276 17.0359 8.53588C17.0359 7.689 16.3469 7 15.5 7Z",
    fill: "#CACACA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.5 11.1224V19.8776C17.9138 19.8776 19.8776 17.9138 19.8776 15.5C19.8776 13.0862 17.9138 11.1224 15.5 11.1224Z",
    fill: "#CACACA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.5 17.4572C14.4208 17.4572 13.5428 16.5792 13.5428 15.5C13.5428 14.4208 14.4208 13.5428 15.5 13.5428C16.5792 13.5428 17.4572 14.4208 17.4572 15.5C17.4572 16.5792 16.5792 17.4572 15.5 17.4572Z",
    fill: "#CACACA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.5 13.5428V17.4572C16.5792 17.4572 17.4572 16.5792 17.4572 15.5C17.4572 14.4208 16.5792 13.5428 15.5 13.5428Z",
    fill: "#9F9F9F"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 17,
    height: 17,
    fill: "white",
    transform: "translate(7 7)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSelInfecteds);
export default __webpack_public_path__ + "static/media/SelInfecteds.ecf9d2d17c0cba6efad4688cba8c6696.svg";
export { ForwardRef as ReactComponent };